import React, { createContext, useContext, useState, useEffect } from 'react';
import { VacationContextType } from '../types';

const VacationContext = createContext<VacationContextType | undefined>(undefined);

interface VacationProviderProps {
  children: React.ReactNode;
}

export function VacationProvider({ children }: VacationProviderProps) {
  const [isVacationMode, setIsVacationMode] = useState(() => {
    const stored = localStorage.getItem('vacation-mode');
    return stored ? JSON.parse(stored) : false;
  });

  useEffect(() => {
    localStorage.setItem('vacation-mode', JSON.stringify(isVacationMode));
  }, [isVacationMode]);

  const toggleVacationMode = () => {
    setIsVacationMode(prev => !prev);
  };

  return (
    <VacationContext.Provider value={{ isVacationMode, toggleVacationMode }}>
      {children}
    </VacationContext.Provider>
  );
}

export function useVacationMode() {
  const context = useContext(VacationContext);
  if (context === undefined) {
    throw new Error('useVacationMode must be used within a VacationProvider');
  }
  return context;
}